<template>
  <b-popover
    id="filtroPopoverLog"
    ref="popover"
    target="popover-filtro-log"
    triggers="click"
    :show.sync="popoverShow"
    placement="bottom"
    custom-class="multiselect-popover-filtro"
  >
    <div
      slot="title"
      style="text-align: center;"
    >
      <span
        style="vertical-align: sub"
      >Filtros adicionais</span>
      <b-button
        variant="none"
        class="close"
        @click="onClose"
      >
        <span aria-hidden="true">&times;</span>
      </b-button>
    </div>
    <b-row>
      <b-col cols="12">
        <b-form-group label="Recursos">
          <v-select
            v-model="value.telas"
            :options="telas"
            label="descricao"
            :multiple="true"
            :clearable="false"
          >
            <template v-slot:option="option">
              {{ option.descricao }}
            </template>
          </v-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-form-group label="Eventos">
          <v-select
            v-model="value.eventos"
            :options="eventos"
            label="descricao"
            :multiple="true"
            :clearable="false"
          >
            <template v-slot:option="option">
              {{ option.descricao }}
            </template>
          </v-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-form-group label="Processos">
          <v-select
            v-model="value.processos"
            :options="processos"
            label="descricao"
            :multiple="true"
            :clearable="false"
          >
            <template v-slot:option="option">
              {{ option.descricao }}
            </template>
          </v-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-form-group>
          <empresa-multiselect
            ref="filtroEmpresa"
            v-model="value.empresas"
            label="Empresas"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-form-group>
          <usuario-interno-select
            ref="filtroUsuarioInterno"
            v-model="value.usuarios"
            :multiple="true"
            :label="'Usuários'"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </b-popover>
</template>

<style lang="scss">
.multiselect-popover-filtro {
  min-width: 380px;
  max-width: 500px;
}

.multiselect-popover-filtro .arrow {
  visibility: hidden;
}

.multiselect-popover-filtro .popover-body {
  max-height: calc(70vh - 132px);
  overflow-y: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar-track {
      border-radius: 10px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar {
      width: 10px;
      background-color: #f5f5f5;
      }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background-color: #bfbfbf;
    }
}
</style>

<script>
import vSelect from 'vue-select'
import api from '@/app-modulo/comuns/log/shared/services/api'

export default {
  name: 'FiltroAdicionalLog',
  components: {
    vSelect,
    EmpresaMultiselect: () => import('@/shared/components/empresa-multiselect/EmpresaMultiselect.vue'),
    UsuarioInternoSelect: () => import('@/shared/components/usuario-interno-select/UsuarioInternoSelect.vue'),
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      popoverShow: false,
      telas: [],
      eventos: [],
      processos: [],
    }
  },
  created() {
    api.getTelas()
      .then(payload => {
        this.telas = payload.data
      })

    api.getEventos()
      .then(payload => {
        this.eventos = payload.data
      })

    api.getProcessos()
      .then(payload => {
        this.processos = payload.data
      })
  },
  methods: {
    onClose() {
      this.popoverShow = false
    },
  },
}
</script>
